// extracted by mini-css-extract-plugin
export default {"link":"menu-lateral_link__2pWvC","linkIcon":"menu-lateral_linkIcon__WIbU7"};